<template>
    <div>
        <b-form-select :state="state" :disabled="disabled" @change="updateValue()" v-model="localValue" :options="durations"></b-form-select>
    </div>
</template>

<script>
export default {

    props: ['value', 'disabled', 'state'],
    data() {
        return {
            localValue: null,
            step: this.$settings.durationStep || 15
        }
    },
    watch: {
        value(newValue) {
            this.localValue = newValue;
        }
    },
    methods: {
        updateValue() {
            this.$emit('input', this.localValue);
            this.$emit('change', this.localValue);

        }
    },
    created() {
        this.localValue = this.value;
    },
    computed: {
        durations() {
            let data = [];
            for (let hours = 0; hours <= 6; hours++) {
                for (let minutes = 0; minutes < 60; minutes = minutes + this.step) {
                    if (!minutes && !hours)
                        continue
                    data.push({
                        text: ((hours > 0) ? hours + this.$t('h') + '  ' : '') + ((minutes > 0) ? minutes + this.$t('min') + '  ' : ''),
                        value: hours * 60 + minutes
                    });
                }
            }
            return data;

        }
    }

}
</script>
